import {Store} from '@gongxigames/framework/core/fragments/store/Store';
import {UIMenuBarEvents} from '@gongxigames/framework/slotV2/ui/services/UIMenu/UIMenuEmitter';

export const uiMenuStore = Store.createStore({
    menuOpened: Store.signal(false),
    heightPortrait: Store.signal(190),
    heightLandscape: Store.signal(160),
    activePage: Store.signal('info' as keyof UIMenuBarEvents),
});